<app-message [active]="!!errorMsg" [message]="errorMsg"/>
<app-loading [active]="isLoading"/>

<div *ngIf="!isLoading">
  <div *ngIf="!readOnly" class="pb-3">
    <div [style]="isMobile ? 'width: 92vw;' : ''"
         [class.flex]="isMobile" [class.overflow-x-auto]="isMobile">
      <div *ngIf="isLoadingRequirements">
        <table class="w-full">
          <tr *ngFor="let number of [0,1,2]">
            <td class="pr-2">
              <p-skeleton styleClass="mb-1" height="22px" width="100px"/>
            </td>
            <td class="pt-1 pb-1 w-full">
              <p-skeleton styleClass="mb-1" height="28px"/>
            </td>
            <td class="pt-1 pb-1 w-full">
              <p-skeleton styleClass="mb-1" height="28px"/>
            </td>
            <td class="pt-1 pb-1 w-full">
              <p-skeleton styleClass="mb-1" height="28px"/>
            </td>
          </tr>
        </table>
      </div>
      <div *ngIf="!isLoadingRequirements" class="table-design">
        <table class="w-full">
          <tr>
            <th class="col-player">{{ 'PLAYER' | translate }}</th>
            @if (showAverage) {
              <th>{{ 'AVERAGE' | translate }}</th>
            }
            <th *ngFor="let performanceType of domainPerformanceTypes">
              {{ performanceType.name }}
            </th>
          </tr>
          <tr *ngFor="let player of players; let i = index">
            <td class="col-player">
              @if (match?.matchReport) {
                @if (memberPlayers) {
                  @if (i === 0) {
                    <p-select appendTo="body"
                              [options]="memberPlayers"
                              [placeholder]="'PLEASE_SELECT' | translate"
                              [(ngModel)]="selectedMemberPlayer"
                              [filter]="memberPlayers?.length > 10"
                              [panelStyle]="isMobile ? undefined : {'width': '650px'}"
                              optionLabel="displayName"
                              class="grid-comp-full-width">
                      <ng-template let-option #item>
                        <div [class.flex]="!isMobile">
                          <div class="flex-1">{{ option.displayName }}</div>
                          @if (option.teamName) {
                            <div class="text-gray-500" [class.pt-1]="isMobile">{{ option.teamName }}</div>
                          }
                        </div>
                      </ng-template>
                      <ng-template let-option #selectedItem>
                        <div class="flex">
                          <div class="flex-1">{{ option.displayName }}</div>
                          @if (option.teamName) {
                            <div class="text-gray-500">{{ option.teamName }}</div>
                          }
                        </div>
                      </ng-template>
                    </p-select>
                  } @else if (i === 1) {
                    <div class="flex">
                      <div class="flex-1 pr-1">
                        <p-select appendTo="body"
                                  [options]="memberPlayers"
                                  [placeholder]="'PLEASE_SELECT' | translate"
                                  [(ngModel)]="selectedMemberPlayerDouble1"
                                  [filter]="memberPlayers?.length > 10"
                                  [panelStyle]="isMobile ? undefined : {'width': '650px'}"
                                  optionLabel="displayName"
                                  class="grid-comp-full-width">
                          <ng-template let-option #item>
                            <div [class.flex]="!isMobile">
                              <div class="flex-1">{{ option.displayName }}</div>
                              @if (option.teamName) {
                                <div class="text-gray-500" [class.pt-1]="isMobile">{{ option.teamName }}</div>
                              }
                            </div>
                          </ng-template>
                          <ng-template let-option #selectedItem>
                            <div class="flex">
                              <div class="flex-1">{{ option.displayName }}</div>
                              @if (option.teamName) {
                                <div class="text-gray-500">{{ option.teamName }}</div>
                              }
                            </div>
                          </ng-template>
                        </p-select>
                      </div>
                      <div class="flex-1 pl-1">
                        <p-select appendTo="body"
                                  [options]="memberPlayers"
                                  [placeholder]="'PLEASE_SELECT' | translate"
                                  [(ngModel)]="selectedMemberPlayerDouble2"
                                  [filter]="memberPlayers?.length > 10"
                                  [panelStyle]="isMobile ? undefined : {'width': '650px'}"
                                  optionLabel="displayName"
                                  class="grid-comp-full-width">
                          <ng-template let-option #item>
                            <div [class.flex]="!isMobile">
                              <div class="flex-1">{{ option.displayName }}</div>
                              @if (option.teamName) {
                                <div class="text-gray-500" [class.pt-1]="isMobile">{{ option.teamName }}</div>
                              }
                            </div>
                          </ng-template>
                          <ng-template let-option #selectedItem>
                            <div class="flex">
                              <div class="flex-1">{{ option.displayName }}</div>
                              @if (option.teamName) {
                                <div class="text-gray-500">{{ option.teamName }}</div>
                              }
                            </div>
                          </ng-template>
                        </p-select>
                      </div>
                    </div>
                  }
                } @else {
                  <p-select appendTo="body"
                            [options]="participants"
                            [placeholder]="'PLEASE_SELECT' | translate"
                            [(ngModel)]="selectedParticipant"
                            [filter]="participants?.length > 10"
                            [panelStyle]="isMobile ? undefined : {'width': '650px'}"
                            optionLabel="displayName"
                            class="grid-comp-full-width">
                    <ng-template let-option #item>
                      <div [class.flex]="!isMobile">
                        <div class="flex-1">{{ option.displayName }}</div>
                        @if (option.team) {
                          <div class="text-gray-500" [class.pt-1]="isMobile">{{ option.team.name }}</div>
                        }
                      </div>
                    </ng-template>
                  </p-select>
                }
              } @else {
                {{ player | playerPipe }}
              }
            </td>
            @if (showAverage) {
              <td>
                <p-inputNumber [id]="'pinput_' + player.id + '_average'"
                               [disabled]="averagesDisabled"
                               [suffix]="' Ø'" locale="de-DE" [max]="180"
                               [minFractionDigits]="2" [maxFractionDigits]="2"
                               [(ngModel)]="inputAverages[i]"
                               (keydown.enter)="savePerformances()"
                               class="w-full" styleClass="grid-comp-full-width"/>
              </td>
            }
            <td
              *ngFor="let performanceType of ((i % 2 == 0 || useMemberPlayers) ? domainPerformanceTypes : domainPerformanceTypesOdd); let j = index"
              [rowSpan]="(!performanceType.tournamentKindCd || performanceType.tournamentKindCd === 'SINGLE' || match?.matchReport) ? 1 : 2">
              <div>
                @if (showPerformanceInput(performanceType, i)) {
                  <input pInputText type="text" class="p-inputtext w-full"
                         [id]="'pinput_' + player.id + '_' + performanceType.id"
                         [(ngModel)]="inputValues[i][j]"
                         (keydown.enter)="savePerformances()"
                         maxlength="100"/>
                }
                @if (player.refresh) {
                  <input pInputText type="text" class="p-inputtext w-full ng-invalid ng-dirty" maxlength="100"/>
                }
              </div>
            </td>
          </tr>
        </table>
        <div class="text-right pt-2">
          <p-button styleClass="p-button-sm" [label]="('ACTION_SAVE' | translate)" (click)="savePerformances()"/>
        </div>
      </div>
    </div>
  </div>

  <p-table [value]="data"
           [loading]="isLoading"
           responsiveLayout="scroll"
           selectionMode="single"
           [stripedRows]="true" [showGridlines]="true" class="p-datatable-sm">

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 240px;" class="text-center">{{ 'PLAYER' | translate }}</th>
        <th style="width: 240px;" class="text-center">{{ 'BEST_PERFORMANCE' | translate }}</th>
        <th style="width: 100px;" class="text-center">{{ 'VALUE' | translate }}</th>
        <th style="width: 60px;" class="text-center">{{ (isMobile ? 'COUNT_SHORT' : 'COUNT') | translate }}</th>
        <th *ngIf="!readOnly"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
      <tr *ngIf="data.header" class="sub-header">
        <th colspan="80">
          {{ data.name }}
        </th>
      </tr>
      <tr *ngIf="!data.header">
        <td>
          <span *ngIf="!(data.performanceTypeCd === 'SGD')">
            {{ data.performancePlayers[0].player | playerPipe }}
          </span>
          <span *ngIf="data.performanceTypeCd === 'SGD'">
            {{ data | performancePlayerPipe }}
          </span>
        </td>
        <td>
          {{ data.performanceTypeCd | domainValuePipe: 'bestperformance-type' }}
        </td>
        <td class="text-center">
          {{ data.value }}
        </td>
        <td class="text-center">
          {{ data.count }}
        </td>
        <td *ngIf="!readOnly" class="cell-nowrap">
          <p-button icon="pi pi-pencil"
                    styleClass="p-button-rounded p-button-text p-button-primary no-padding"
                    [pTooltip]="'ACTION_EDIT' | translate" (click)="onEdit(data)"/>
          <p-button icon="pi pi-trash"
                    styleClass="p-button-rounded p-button-text p-button-danger no-padding"
                    [pTooltip]="'ACTION_DELETE' | translate" (click)="onDelete(data)"/>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="pt-4 pb-4">
          {{ 'NO_PERFORMANCES_AVAILABLE' | translate }}<br>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <!--<div *ngIf="!readOnly" class="mt-3">
    <button pButton pRipple type="button" class="p-button-outlined" styleClass="p-button-sm"
            [label]="('ACTION_ADD' | translate) + '...'" (click)="addItem()"></button>
  </div>-->
</div>
